import { useState, useRef, useEffect } from "react";
import { Typography, Tooltip } from "antd";

const { Text } = Typography;

const EllipsisWithTooltip = ({ text, maxWidth = "200px" }) => {
  const textRef = useRef(null);
  const [isEllipsized, setIsEllipsized] = useState(false);

  useEffect(() => {
    const el = textRef.current;
    if (el) {
      const isOverflowing = el.scrollWidth > el.clientWidth;
      setIsEllipsized(isOverflowing);
    }
  }, [text]);

  const textStyle = {
    maxWidth,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
    cursor: isEllipsized ? "pointer" : "default",
  };

  const textNode = (
    <Text ref={textRef} style={textStyle}>
      {text}
    </Text>
  );

  return isEllipsized ? (
    <Tooltip color="white" styles={{ body: { color: "black" } }} title={text}>
      {textNode}
    </Tooltip>
  ) : (
    textNode
  );
};

export default EllipsisWithTooltip;
